import { applyMiddleware, createStore } from "redux";
import { thunk } from "redux-thunk";
import reducers from "../reducers";
import firestoreConfig from "configs/FirestoreConfig";
import firebase from "configs/FirebaseConfig";
import { createFirestoreInstance } from "redux-firestore";

const composeEnhancers = (f) => f;

// Bewust GEEN redux-localstorage-simple meer.
//
// Hier stond `save({ ignoreStates: ["queries"] })`. Zonder `states` schrijft die
// middleware de complete state onder één key weg, en zonder `debounce` gebeurt
// dat bij ELKE dispatch. In de state zit `firestoreReducer`, dat de hele
// Firestore-cache dubbel vasthoudt (`data` op id + `ordered` als arrays). Elke
// snapshot van elke listener leverde dus een synchrone JSON.stringify van
// megabytes op de main thread op — waarna het alsnog niet in de ~5MB
// localStorage-quota paste. Vandaar de QuotaExceededError-afhandeling in
// components/ErrorBoundary.js.
//
// Teruggelezen werd het nooit: `load()` is hier nooit gebruikt en de
// theme-reducer leest localStorage niet zelf (in tegenstelling tot wat de oude
// comment hier beweerde). Het was dus puur overhead. Wil je in de toekomst iets
// bewaren, geef dan expliciet `states` mee (nooit `firestoreReducer`) plus een
// `debounce`, en gebruik `load()` alleen per slice — niet als preloadedState
// over de hele boom, want dat vervangt de theme-slice compleet en dan ontbreken
// nieuwe velden uit initTheme (bv. navType) bij bestaande gebruikers.
try {
  // Eenmalig opruimen: bestaande browsers hebben de oude blob nog staan.
  localStorage.removeItem("redux_localstorage_simple");
} catch (e) {
  // Storage geblokkeerd (private mode): dan valt er ook niets op te ruimen.
}

const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

export const rrfProps = {
  firebase,
  config: firestoreConfig,
  dispatch: store.dispatch,
  createFirestoreInstance,
};

export default store;
